import BaseQuery from "@/stateManagement/BaseQuery";
import { filterNilValue } from "@datorama/akita";
import type { ProductsQuery } from "@modules/products/queries/ProductsQuery";
import { productsQueryToken } from "@modules/products/tokens";
import { map, of, switchMap } from "rxjs";
import { inject, singleton } from "tsyringe";

import type { RewardsReferralProgramState } from "../stores/RewardsReferralProgramStore";
import RewardsReferralProgramStore from "../stores/RewardsReferralProgramStore";

@singleton()
class RewardsReferralProgramQuery extends BaseQuery<RewardsReferralProgramState> {
    constructor(
        @inject(productsQueryToken)
        private readonly productsQuery: ProductsQuery,
        protected store: RewardsReferralProgramStore
    ) {
        super(store);
    }

    referralProgram$ = this.select((state) => state.referralProgram).pipe(
        filterNilValue()
    );

    isReferralReward$ = this.referralProgram$.pipe(
        map(
            ({ prizeForSender, prizeForReceiver }) =>
                !!(prizeForSender.rewarding || prizeForReceiver.rewarding)
        )
    );

    receiverReward$ = this.referralProgram$.pipe(
        map((referralProgram) => referralProgram.prizeForReceiver.rewarding)
    );
    freeProductFromReceiverReward$ = this.receiverReward$.pipe(
        switchMap((reward) =>
            reward && reward.type === "free_product"
                ? this.productsQuery.selectProduct(reward.productId)
                : of(null)
        )
    );

    status$ = this.select((state) => state.status);
}

export default RewardsReferralProgramQuery;
